import { APICore } from "./apiCore";
import compressImage from "../compressImage";

const api = new APICore();

// compressImage sempre gera JPEG: troca a extensão do nome original.
const toJpegFileName = (file: File | Blob) => {
  const originalName = (file as File).name || "imagem";
  return `${originalName.replace(/\.[^.]+$/, "")}.jpg`;
};

const criarArquivo = async (
  files: FileList | Blob[],
  tipoarquivo_id = "1",
  relacionamento_id = "",
  compressImageValidation = false,
  relacionamentoArquivo = "historico_id"
) => {
  const formData = new FormData();
  for (const file of Array.from(files)) {
    if (
      compressImageValidation &&
      file.type.startsWith("image/") &&
      file.type !== "image/gif"
    ) {
      try {
        // compressImage devolve o próprio `file` (mesma referência) quando
        // não há o que comprimir; nesse caso segue o envio do original.
        const compressed = await compressImage(file);
        if (compressed !== file) {
          formData.append("arquivos", compressed, toJpegFileName(file));
          continue;
        }
      } catch (error) {
        // Falha na compressão: envia o original em vez de bloquear o upload.
      }
    }
    formData.append("arquivos", file);
  }

  formData.append("tipoarquivo_id", tipoarquivo_id);
  formData.append(relacionamentoArquivo, relacionamento_id);

  return api.create("/arquivo", formData, {
    headers: { "Content-type": "multipart/form-data" },
  });
};

const deletarArquivo = (id: string) => {
  return api.delete(`/arquivo/${id}`);
};

export { criarArquivo, deletarArquivo };
